import React from 'react';
import { IntlShape } from 'react-intl';
import HomeLink from '../components/HomeLink';
import LinkAndAnchor from '../components/LinkAndAnchor';
import messages from './messages.mjs';

const generateIntelligencePageBreadcrumbs = (
  intl: IntlShape,
  route: string,
  messagesPrefix: string,
) => ([
  <HomeLink />,
  <LinkAndAnchor route="i" passHref>
    {intl.formatMessage(messages.intelligence)}
  </LinkAndAnchor>,
  <LinkAndAnchor route={route} passHref>
    {intl.formatMessage(messages[`${messagesPrefix}.title`])}
  </LinkAndAnchor>,
]);

export default generateIntelligencePageBreadcrumbs;
